import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  container: {
    textAlign: 'center',
    marginTop: '50px',
    marginBottom: '50px',
  },
  terms: {
    fontSize: '20px',
    fontWeight: '600',
    fontFamily: 'Open Sans',
    color: '#7C839D',
  },
  companyLink: {
    textDecoration: 'underline',
    color: '#2C1482',
  },
}));
